import { render, staticRenderFns } from "./BreadCrumps.vue?vue&type=template&id=367e23d8&"
import script from "./BreadCrumps.vue?vue&type=script&lang=js&"
export * from "./BreadCrumps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports